import { useMemo } from "react";
import { useTranslations } from "next-intl";
import { SCard } from "@/components/Card/SCard";
import { AuthLayout } from "./AuthLayout";
import MfaVerifyContent from "./mfa-verify/MfaVerifyContent";
import { useAuth } from "@/lib/auth/AuthContext";

export function MfaVerifyPage() {
  const t = useTranslations("mfaVerify");
  const { state } = useAuth();
  const initialTimeRemaining = useMemo(() => {
    // The MFA-pending access cookie is HttpOnly so the cockpit can't
    // decode its JWT. Backend exposes the expiry epoch (millis) in the
    // login response body, threaded through AuthContext state.
    if (state.kind !== "mfa-required") return 300;
    return Math.max(0, Math.floor((state.mfaExpiresAt - Date.now()) / 1000));
  }, [state]);

  return (
    <AuthLayout>
      <SCard header={t("title")} outline="outline-quaternary" shadow="shadow-xl">
        <MfaVerifyContent initialTimeRemaining={initialTimeRemaining} />
      </SCard>
    </AuthLayout>
  );
}
